Jelly.Interface.Hide_Lightbox = function()
{
	// Fade lightbox out
	Jelly.jQuery(Jelly.Interface.Lightbox_Element).fadeOut("fast");
};